// Google Analytics 4 Configuration
import { GA_TRACKING_ID } from "../config";

// Initialize Google Analytics
export const initGA = () => {
  // The base script is already loaded in index.html
  // This function now ensures the page_path is set correctly
  if (typeof window !== "undefined") {
    // Wait for gtag to be available
    const waitForGtag = setInterval(() => {
      if (window.gtag) {
        clearInterval(waitForGtag);
        window.gtag("config", GA_TRACKING_ID, {
          page_path: window.location.pathname,
          send_page_view: true,
          debug_mode: true,
        });
        // console.log('GA4 initialized with ID:', GA_TRACKING_ID);
      }
    }, 100);

    // Clear interval after 5 seconds to prevent infinite checking
    setTimeout(() => clearInterval(waitForGtag), 5000);
  } else {
    console.warn("GA4 not initialized - window not defined");
  }
};

// Track page views
export const pageview = (url, userInfo = null) => {
  if (typeof window !== "undefined") {
    // Wait for gtag to be available
    const waitForGtag = setInterval(() => {
      if (window.gtag) {
        clearInterval(waitForGtag);
        
        // Base config
        const config = {
          page_path: url,
          send_page_view: true,
          debug_mode: true,
        };
        
        // Add user info if available
        if (userInfo?.name) {
          config.custom_map = {
            custom_parameter_1: 'user_name',
            custom_parameter_2: 'page_user_info'
          };
        }
        
        window.gtag("config", GA_TRACKING_ID, config);
        
        // Send additional event with user and page info
        if (userInfo?.name) {
          const timestamp = new Date().toISOString();
          const readableTime = new Date().toLocaleString();
          window.gtag("event", "page_view_with_user", {
            user_name: userInfo.name,
            page_user_info: `${userInfo.name},  ${url},  ${readableTime}`,
            page_path: url,
            timestamp: timestamp,
          });
        }
        
        // console.log('GA4 pageview:', url, userInfo);
      }
    }, 100);

    // Clear interval after 5 seconds to prevent infinite checking
    setTimeout(() => clearInterval(waitForGtag), 5000);
  }
};

// Track events
export const event = ({ action, ...params }) => {
  if (typeof window !== "undefined") {
    // Wait for gtag to be available
    const waitForGtag = setInterval(() => {
      if (window.gtag) {
        clearInterval(waitForGtag);
        // Format parameters for GA4
        const formattedParams = Object.entries(params).reduce(
          (acc, [key, value]) => {
            acc[key] = value;
            return acc;
          },
          {},
        );

        window.gtag("event", action, formattedParams);
        // console.log('GA4 event sent:', { action, ...formattedParams });
      }
    }, 100);

    // Clear interval after 5 seconds to prevent infinite checking
    setTimeout(() => clearInterval(waitForGtag), 5000);
  } else {
    console.warn("GA4 event not sent - window not defined:", {
      action,
      ...params,
    });
  }
};
